<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="6">
                <app-filtro-tabela
                    v-model="filtro"
                    v-if="mostrarFiltro"
                ></app-filtro-tabela>
            </b-col>
            <b-col sm="12" md="12" lg="6">
                <slot name="botoes"></slot>
            </b-col>
        </b-row>
        <b-table
            :striped="striped"
            :hover="hover"
            :bordered="bordered"
            :small="small"
            :responsive="true"
            :id="idTabela"
            :ref="idTabela"
            :items="itens"
            :fields="campos"
            empty-text="Não existem dados a serem exibidos"
            empty-filtered-text="Não existem dados a serem exibidos"
            :show-empty="mostrarVazio"
            :per-page="itensPorPaginaSelected"
            :current-page="paginaAtual"
            :filter="filtro"
            :filter-function="filtrar"
            :busy="emProcessamento"
            @filtered="onFiltered"
        >
            <template
                v-for="campo in campos"
                :slot="campo.key"
                slot-scope="data"
            >
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="campo.type === 'date'"
                    >{{
                        deepFind(data.item, campo.key)
                            ? $moment(deepFind(data.item, campo.key)).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}</slot
                >
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="campo.type === 'datetime'"
                    >{{
                        deepFind(data.item, campo.key)
                            ? $moment(deepFind(data.item, campo.key)).format(
                                  'DD/MM/YYYY HH:mm'
                              )
                            : ''
                    }}</slot
                >
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="campo.type === 'status'"
                >
                    <app-status
                        :status="deepFind(data.item, campo.key)"
                    ></app-status>
                </slot>
                <slot
                    :name="campo.key"
                    v-bind="data.item"
                    v-if="mostrarPadrao(campo.type)"
                    >{{ deepFind(data.item, campo.key) }}</slot
                >
            </template>
            <template
                v-for="campo in campos"
                :slot="'FOOT_' + campo.key"
                slot-scope="data"
            >
                <slot :name="'FOOT_' + campo.key" v-bind="data"></slot>
            </template>
            <template
                v-for="campo in campos"
                :slot="'HEAD_' + campo.key"
                slot-scope="data"
            >
                <slot :name="'HEAD_' + campo.key" v-bind="data">{{
                    data.label
                }}</slot>
            </template>
        </b-table>
        <app-paginacao
            :totalItens="totalItens"
            :itensPorPagina="itensPorPaginaSelected"
            v-model="paginaAtual"
            v-if="itensPorPagina > 0"
        >
            <template slot="paginacao">
                <b-form-select
                    v-model="itensPorPaginaSelected"
                    :options="itensPorPaginaOptions"
                ></b-form-select>
            </template>
        </app-paginacao>
    </div>
</template>

<script>
import PaginacaoComponent from './PaginacaoComponent'
import FiltroTabelaComponent from './FiltroTabelaComponent'

export default {
    name: 'app-tabela',
    props: {
        idTabela: {
            type: String,
            default: 'appTabela'
        },
        itens: {
            type: Array
        },
        campos: {
            type: Array
        },
        itensPorPagina: {
            type: Number,
            default: 5
        },
        emProcessamento: {
            type: Boolean,
            default: false
        },
        mostrarFiltro: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        hover: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: true
        },
        small: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            mostrarVazio: true,
            totalItens: 0,
            paginaAtual: 1,
            filtro: '',
            itensPorPaginaSelected: this.itensPorPagina,
            itensPorPaginaOptions: [
                { value: 5, text: 5 },
                { value: 10, text: 10 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ]
        }
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalItens = filteredItems.length
            this.paginaAtual = 1
        },

        filtrar(data, filtro) {
            let retorno = false
            if (filtro) {
                this.campos.forEach((campo) => {
                    if (campo.filterable) {
                        let tempText
                        if (campo.key.split('.').length === 1) {
                            if (typeof data[campo.key] === 'string') {
                                tempText = data[campo.key].textoNormalizado()
                            } else {
                                tempText = JSON.stringify(
                                    data[campo.key]
                                ).textoNormalizado()
                            }
                        } else {
                            tempText = JSON.stringify(
                                data[campo.key.split('.')[0]]
                            ).textoNormalizado()
                        }
                        retorno =
                            retorno ||
                            tempText.search(filtro.textoNormalizado()) !== -1
                    }
                })
            } else {
                retorno = true
            }
            return retorno
        },

        deepFind(obj, path) {
            let paths = path.split('.')
            let current = obj

            for (let i = 0; i < paths.length; ++i) {
                if (current[paths[i]] === undefined) {
                    return undefined
                } else {
                    current = current[paths[i]]
                }
            }
            return current
        },

        mostrarPadrao(tipo) {
            return tipo !== 'date' && tipo !== 'datetime' && tipo !== 'status'
        }
    },

    watch: {
        itens() {
            if (this.itens) {
                this.totalItens = this.itens.length
            }
        }
    },

    components: {
        appPaginacao: PaginacaoComponent,
        appFiltroTabela: FiltroTabelaComponent
    }
}
</script>
